import { postUserAvatar } from '../apis/profile.api';

export const uploadFile = async (
  file: any,
  setUrl: any,
  setResult: any,
  oldAvatar: any
) => {
  try {
    const data = await postUserAvatar({ avatar: file });
    if (data) {
      setResult(true);
      setUrl(data);
      console.log('set temp');
    }
    console.log('post image to server success');
  } catch (err) {
    console.log(err);
    setResult(false);
  }
};
